/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Mag7x_TitleInputs */

const en_strategy_partner_mag7x_title = /** @type {(inputs: Strategy_Partner_Mag7x_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise Mag7X ATP`)
};

const de_strategy_partner_mag7x_title = /** @type {(inputs: Strategy_Partner_Mag7x_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise Mag7X-Strategie`)
};

const pt_br2_strategy_partner_mag7x_title = /** @type {(inputs: Strategy_Partner_Mag7x_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estratégia Bitwise Mag7X`)
};

const tr_strategy_partner_mag7x_title = /** @type {(inputs: Strategy_Partner_Mag7x_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise Mag7X Stratejisi`)
};

const zh_cn2_strategy_partner_mag7x_title = /** @type {(inputs: Strategy_Partner_Mag7x_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise Mag7X 策略`)
};

const zh_hk2_strategy_partner_mag7x_title = /** @type {(inputs: Strategy_Partner_Mag7x_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise Mag7X 策略`)
};

const ko_kr2_strategy_partner_mag7x_title = /** @type {(inputs: Strategy_Partner_Mag7x_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise Mag7X 전략`)
};

const ru_ru2_strategy_partner_mag7x_title = /** @type {(inputs: Strategy_Partner_Mag7x_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегия Bitwise Mag7X`)
};

const es_419_strategy_partner_mag7x_title = /** @type {(inputs: Strategy_Partner_Mag7x_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrategia Bitwise Mag7X`)
};

/**
* | output |
* | --- |
* | "Bitwise Mag7X ATP" |
*
* @param {Strategy_Partner_Mag7x_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_mag7x_title = /** @type {((inputs?: Strategy_Partner_Mag7x_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Mag7x_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_mag7x_title(inputs)
	if (locale === "de") return de_strategy_partner_mag7x_title(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_mag7x_title(inputs)
	if (locale === "tr") return tr_strategy_partner_mag7x_title(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_mag7x_title(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_mag7x_title(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_mag7x_title(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_mag7x_title(inputs)
	return es_419_strategy_partner_mag7x_title(inputs)
});